import { module as BaseModule } from "modujs"

export default class extends BaseModule {
  init() {
    this.visibleState = false
    this.state = {
      chronologies: [],
      typology: false,
      communautes: [],
      communes: [],
    }

    this.chronologieRadioInputs = document.querySelectorAll(
      "[data-filter-chronologie]"
    )
    this.typologyRadioInputs = document.querySelectorAll(
      "[data-filter-typologie]"
    )
    this.communauteRadioInputs = document.querySelectorAll(
      "[data-filter-communaute]"
    )
    this.communeRadioInputs = document.querySelectorAll("[data-filter-commune]")

    this.filterToggleBtns = document.querySelectorAll("[data-filter-toggle]")
    this.filterBox = document.querySelector("[data-filter-box]")

    this.filterToggleBtns.forEach((btn) => {
      btn.addEventListener("click", this.toggleFilter.bind(this))
    })

    this.chronologieRadioInputs.forEach((input) => {
      input.addEventListener("change", this.handleChronologyChange.bind(this))
    })

    this.typologyRadioInputs.forEach((input) => {
      input.addEventListener("change", this.handleTypologyChange.bind(this))
    })

    this.communauteRadioInputs.forEach((input) => {
      input.addEventListener("change", this.handleCommunauteChange.bind(this))
    })

    this.communeRadioInputs.forEach((input) => {
      input.addEventListener("change", this.handleCommuneChange.bind(this))
    })

    this.resetBtns = document.querySelectorAll("[data-map-filter-reset]")
    this.resetChronologie = this.resetBtns[0]
    this.resetTypologies = this.resetBtns[1]
    this.resetCommunautes = this.resetBtns[2]
    this.resetCommunes = this.resetBtns[3]

    this.resetChronologie.addEventListener(
      "click",
      this.onResetChronologie.bind(this)
    )
    this.resetTypologies.addEventListener(
      "click",
      this.onResetTypologies.bind(this)
    )
    this.resetCommunautes.addEventListener(
      "click",
      this.onResetCommunautes.bind(this)
    )
    this.resetCommunes.addEventListener(
      "click",
      this.onResetCommunes.bind(this)
    )

    this.resetAllBtn = document.querySelector("[data-map-filter-reset-all]")
    this.resetAllBtn.addEventListener("click", this.onResetAll.bind(this))

    this.updateResetAllBtnVisibility()
  }

  hasActiveFilters() {
    return (
      this.state.chronologies.length > 0 ||
      this.state.typology !== false ||
      this.state.communautes.length > 0 ||
      this.state.communes.length > 0
    )
  }

  updateResetAllBtnVisibility() {
    if (this.hasActiveFilters()) {
      this.resetAllBtn.classList.remove("hidden")
    } else {
      this.resetAllBtn.classList.add("hidden")
    }
  }

  triggerMapUpdate() {
    window._selection = this.state
    const update = new CustomEvent("map:selection")
    window.dispatchEvent(update)
  }

  onResetAll() {
    this.onResetChronologie()
    this.onResetTypologies()
    this.onResetCommunautes()
    this.onResetCommunes()
    this.updateResetAllBtnVisibility()
  }

  onResetChronologie() {
    this.chronologieRadioInputs.forEach((input) => {
      input.checked = false
    })
    this.state.chronologies = []
    this.resetChronologie.classList.add("hidden")

    this.triggerMapUpdate()
    this.updateResetAllBtnVisibility()
  }

  onResetTypologies() {
    this.typologyRadioInputs.forEach((input) => {
      input.checked = false
    })
    this.state.typology = false
    this.resetTypologies.classList.add("hidden")

    this.triggerMapUpdate()
    this.updateResetAllBtnVisibility()
  }

  onResetCommunautes() {
    this.communauteRadioInputs.forEach((input) => {
      input.checked = false
    })
    this.state.communautes = []
    this.resetCommunautes.classList.add("hidden")

    this.triggerMapUpdate()
    this.updateResetAllBtnVisibility()
  }

  onResetCommunes() {
    this.communeRadioInputs.forEach((input) => {
      input.checked = false
    })
    this.state.communes = []
    this.resetCommunes.classList.add("hidden")

    this.triggerMapUpdate()
    this.updateResetAllBtnVisibility()
  }

  toggleFilter() {
    this.visibleState = !this.visibleState
    this.filterBox.classList.toggle("hidden", !this.visibleState)
  }

  handleChronologyChange(e) {
    const { value } = e.target

    this.state.chronologies = this.state.chronologies.includes(value)
      ? this.state.chronologies.filter((chronology) => chronology !== value)
      : [...this.state.chronologies, value]

    this.resetChronologie.classList.remove("hidden")

    this.updateResetAllBtnVisibility()
    this.triggerMapUpdate()
  }

  handleTypologyChange(e) {
    const { value } = e.target

    this.state.typology = value
    this.state.communautes = []
    this.state.communes = []

    this.communauteRadioInputs.forEach((input) => {
      input.checked = false
    })

    this.communeRadioInputs.forEach((input) => {
      input.checked = false
    })

    this.resetTypologies.classList.remove("hidden")
    this.resetCommunautes.classList.add("hidden")
    this.resetCommunes.classList.add("hidden")

    this.updateResetAllBtnVisibility()
    this.triggerMapUpdate()
  }

  handleCommunauteChange(e) {
    const { value } = e.target

    this.state.communautes = this.state.communautes.includes(value)
      ? this.state.communautes.filter((communaute) => communaute !== value)
      : [...this.state.communautes, value]

    this.state.typology = false
    this.typologyRadioInputs.forEach((input) => {
      input.checked = false
    })

    this.resetTypologies.classList.add("hidden")
    this.resetCommunautes.classList.remove("hidden")

    this.updateResetAllBtnVisibility()
    this.triggerMapUpdate()
  }

  handleCommuneChange(e) {
    const { value } = e.target

    this.state.communes = this.state.communes.includes(value)
      ? this.state.communes.filter((commune) => commune !== value)
      : [...this.state.communes, value]

    this.state.typology = false
    this.typologyRadioInputs.forEach((input) => {
      input.checked = false
    })

    this.resetTypologies.classList.add("hidden")
    this.resetCommunes.classList.remove("hidden")

    this.updateResetAllBtnVisibility()
    this.triggerMapUpdate()
  }
}
